import script from "./period-filter-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./period-filter-box.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__